<div [ngClass]="columnInfoDto.IsReadOnly || dataItem.IsDelete? 'not-allowed can-be-selected' : 'can-be-selected'">
  <div id="{{Id}}-Input" class="mat-form-field">
    <span class="splitscreen">
      <span id="{{Id}}-Name" 
            (click)="clickName()"
            [ngClass]="dataItem.IsDelete? 'left table-strike-out' : 'left'">
        &nbsp;{{name}}&nbsp;
      </span>
      <span id="{{Id}}-Icon" class="right">
        <mat-icon  [ngClass]="columnInfoDto.IsReadOnly || dataItem.IsDelete? 'not-allowed' : ''" 
        class="float-right mat-icon emds-find-control-icon clickable material-icons mat-ligature-font mat-icon-no-color" 
        (click)="clickIcon()">search</mat-icon>
      </span>
    </span>
    <ap-select *ngIf="!hideDropdown" 
        id="cdk-overlay-2" 
        class="mat-optgroup find-control-dropdown-group cdk-overlay-pane">
        <div role="listbox" 
            class="mat-autocomplete-panel emds mat-primary mat-autocomplete-visible" 
            id="{{Id}}">
              <mat-optgroup
                class="find-control-dropdown-group"
                *ngFor="let group of autocompleteGroups"
                [hidden]="hideDropdown || !group.Name"
                [label]="group.Name"
                id="{{Id}}-dropdown"
              >
                <span *ngIf="group.isCollapsable" class="center-icon pull-right pad-chevron" id="{{ baseId }}-toggle-collapse" (click)="toggleCollapsed(group)">
                  <div class="ap-down-chevron" *ngIf="group.isCollapsed" #matOptgroupLabel></div>
                  <div class="ap-up-chevron" *ngIf="!group.isCollapsed" #matOptgroupLabel></div>
                </span>
                <mat-option *ngFor="let option of group.ItemList; let i = index" (click)="changeDropdown($event)"
                id="{{Id}}-Select"
                [hidden]="group.isCollapsed" 
                [disabled]="group.GroupDisabled"
                >
                  {{ getFormattedName(option) }}
                </mat-option>
                <mat-option *ngIf="!group.ItemList.length && !group.isCollapsed" [disabled]="true" translate> No items available </mat-option>
              </mat-optgroup>
        </div>
    </ap-select>
  </div>
</div>
